



























































































































import { Component, Vue } from "vue-property-decorator";
import $api from "../api";

@Component
export default class Menu extends Vue {
  private accessCount: number | string = "--";
  private hasAccessCount: boolean = false;

  mounted() {
    if (this.$store.state.offModel) {
      return;
    }
    this.getAccessCount();
    if (!this.$store.state.hasAccess) {
      this.addAccessCount();
    }
  }

  getAccessCount() {
    $api.students.findAccessCount().then(res => {
      if ((res as any).length > 0) {
        this.accessCount = (res as any)[0].amount;
        this.hasAccessCount = true;
      }
    }).catch(() => {
      this.hasAccessCount = false;
    });
  }

  addAccessCount() {
    $api.students
      .addAccessCount()
      .then(res => {
        this.$store.commit("changeHasAccess");
      })
      .catch(error => {
        console.log(error);
      });
  }
}
